import { useState, useEffect } from "react";
import useSWR from "swr";
import { formatUnixInAppTz } from "../utils/datetime";

type FetchData = { [key: string]: { [timestamp: string]: number } };

const useOccupancy = (monthBackward: number, type: string, enableOccupancy?: boolean) => {
  const [occupancy, setOccupancy] = useState<
    | {
        [key: string]: {
          data: { key: string; value: number; label: string }[];
        };
      }
    | undefined
  >(undefined);

  const { data } = useSWR<FetchData>([
    `${
      type === "monthly"
        ? "v1/thaihealth/graph_data/monthly_carbon_footprint/"
        : "v1/thaihealth/graph_data/monthly_carbon_footprint/"
    }`,
    { month_backward: monthBackward, enable_occupancy: enableOccupancy},
  ]);
  useEffect(() => {
    if (data) {
      const transformedData = transformData(data);
      setOccupancy(transformedData);
    }
  }, [data]);

  const transformData = (
    data: FetchData
  ): {
    [key: string]: {
      data: { key: string; value: number; label: string }[];
    };
  } => {
    const transformedData = Object.keys(data).reduce(
      (
        acc: {
          [key: string]: {
            personnel: number;
            data: { key: string; value: number; label: string }[];
          };
        },
        category
      ) => {
        acc[category] = {
          personnel: category === "energy" ? 250 : 100,
          data: Object.keys(data[category]).map((timestamp) => ({
            key:
              type === "monthly"
                ? formatUnixInAppTz(parseInt(timestamp), "MMM")
                : formatUnixInAppTz(parseInt(timestamp), "HHmm"),
            value:
              type === "monthly"
                ? data[category][timestamp]
                : Math.floor(data[category][timestamp] / 10),
            label:
              type === "monthly"
                ? formatUnixInAppTz(parseInt(timestamp), "MMMM")
                : formatUnixInAppTz(parseInt(timestamp), "MMMM"),
          })),
        };

        return acc;
      },
      {}
    );
    return transformedData;
  };

  return { data: occupancy };
};

export default useOccupancy;
